import { IconProps } from '../icon';

export function BoldIcon(props: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 197.6 256.29"
      {...props}
    >
      <g id="a" />
      <g id="b">
        <g id="c">
          <path d="M0,.25C1.27,.18,2.24,.09,3.22,.09c30.83,.02,61.67-.3,92.49,.19,20.08,.32,39.58,3.92,58.04,12.63,42.59,20.1,42.06,73.04,22.11,95.99-2.82,3.24-6.12,6.15-9.57,8.71-3.41,2.52-7.31,4.4-11.33,6.76,.67,.38,.99,.66,1.37,.76,24.18,6.41,37.66,22.4,40.57,46.88,2.62,22.08-1.82,42.59-17.83,59.12-12.26,12.65-28.02,18.97-45.01,21.97-9.79,1.73-19.81,2.87-29.75,2.98-33.49,.37-66.99,.16-100.49,.17-1.15,0-2.3,0-3.82,0V.25ZM59.85,146.35v63.71c16.66,0,33.02,.79,49.26-.21,18.76-1.15,28.35-10.59,29.01-27.9,.81-21.13-7.15-34.36-30.31-35.46-15.78-.75-31.63-.14-47.96-.14Zm-.11-39.75c11.24,0,21.88,.27,32.49-.11,5.43-.19,10.97-1,16.2-2.46,13.96-3.88,20.87-13.39,20.63-27.45-.27-15.6-6.95-24.66-21.5-28.39-15.7-4.02-31.7-1.52-47.82-2.29v60.69Z" />
        </g>
      </g>
    </svg>
  );
}

export default BoldIcon;
